import React from 'react';
import Burger from "../../components/Burger/Burger";
import Logo from "../../assets/Logo.svg";
import style from "./Header.module.scss";

export default function Header({activeCategory, setActiveCategory, pageServices, pageTeam, pageNews, mainPage}) {
    return (
        <div className='container'>
            <div className={style.header}>
                <img className={style.logo} src={Logo} alt="Logo"/>
                <Burger activeCategory={activeCategory} pageNews={pageNews} mainPage={mainPage} pageTeam={pageTeam} pageServices={pageServices} setActiveCategory={setActiveCategory}/>
            </div>
        </div>
    );
}